import React from "react";

const Info = ({
  style = {},
  className = "",
  width = "13px",
  height = "13px",
  color = "#706F70",
  backgroundColor = "#FFFFFF",
  viewBox = "0 0 13 13",
  ...rest
}) => (
  <svg
    height={height}
    width={width}
    className={className}
    style={style}
    viewBox={viewBox}
    {...rest}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="-Page-Catalog-(9)" transform="translate(-644.000000, -577.000000)">
        <g
          id="baseline-info-24px"
          transform="translate(643.000000, 576.000000)">
          <polygon id="Path" points="0 0 15 0 15 15 0 15" />
          <path
            d="M7.5,1 C3.912,1 1,3.912 1,7.5 C1,11.088 3.912,14 7.5,14 C11.088,14 14,11.088 14,7.5 C14,3.912 11.088,1 7.5,1 Z M8.15,10.75 L6.85,10.75 L6.85,6.85 L8.15,6.85 L8.15,10.75 Z M8.15,5.55 L6.85,5.55 L6.85,4.25 L8.15,4.25 L8.15,5.55 Z"
            id="Shape"
            fill={color}
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Info;
